export default {
// This method make able to print the CFDIs
  install (Vue) {
    Vue.prototype.sendToPrint = () => {
      window.frames['cfdi'].focus()
      window.frames['cfdi'].print()
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/sendToPrint.js